export default {"src":"/_next/static/media/DHL_Logo.946080ef.svg","height":39,"width":176};